document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.lg-auto-bookmark[data-url]');

  function escapeHtml(str = '') {
    return str.replace(/[&<>"']/g, (char) => {
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      return map[char] || char;
    });
  }

  function getMetaContent(doc, selectors) {
    for (const selector of selectors) {
      const el = doc.querySelector(selector);
      if (!el) continue;

      if (el.tagName.toLowerCase() === 'title') {
        const value = el.textContent.trim();
        if (value) return value;
      }

      const content = el.getAttribute('content');
      if (content && content.trim()) return content.trim();

      const text = el.textContent.trim();
      if (text) return text;
    }
    return '';
  }

  function getLinkLabel(url, customLabel) {
    if (customLabel) return customLabel;

    const path = url.replace(/^https?:\/\/[^/]+/, '');

    if (path.startsWith('/products/')) return 'Voir le produit';
    if (path.startsWith('/collections/')) return 'Voir la collection';
    if (path.startsWith('/pages/')) return 'Voir la page';
    if (path.startsWith('/blogs/')) return 'Lire l\u2019article';

    return 'Lire l\u2019article';
  }

  function buildFallback(url, customLabel) {
    const target = new URL(url, window.location.origin);
    const domain = target.hostname.replace(/^www\./, '');
    const label = getLinkLabel(target.href, customLabel);

    return `
      <a href="${escapeHtml(target.href)}" class="lg-bookmark-card lg-bookmark-card--fallback" target="_blank" rel="noopener noreferrer">
        <div class="lg-bookmark-card__body">
          <p class="lg-bookmark-card__domain">${escapeHtml(domain)}</p>
          <h3 class="lg-bookmark-card__title">Ouvrir le lien</h3>
          <span class="lg-bookmark-card__link">${escapeHtml(label)}</span>
        </div>
      </a>
    `;
  }

  blocks.forEach(async (block) => {
    const rawUrl = block.dataset.url;
    const customLabel = block.dataset.label || '';
    if (!rawUrl) {
      block.remove();
      return;
    }

    try {
      const target = new URL(rawUrl, window.location.origin);

      if (target.origin !== window.location.origin) {
        block.innerHTML = buildFallback(target.href, customLabel);
        return;
      }

      const response = await fetch(target.href, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const title =
        getMetaContent(doc, [
          'meta[property="og:title"]',
          'meta[name="twitter:title"]',
          'title',
          'h1'
        ]) ||
        target.pathname.split('/').pop().replace(/-/g, ' ');

      const description =
        getMetaContent(doc, [
          'meta[property="og:description"]',
          'meta[name="description"]',
          'meta[name="twitter:description"]'
        ]) || '';

      let image =
        getMetaContent(doc, [
          'meta[property="og:image"]',
          'meta[name="twitter:image"]'
        ]) || '';

      if (!image) {
        const firstImage = doc.querySelector('main img, article img, .article img, img');
        if (firstImage) {
          image = firstImage.getAttribute('src') || '';
        }
      }

      if (image.startsWith('//')) {
        image = `${window.location.protocol}${image}`;
      } else if (image.startsWith('/')) {
        image = `${window.location.origin}${image}`;
      }

      const domain = target.hostname.replace(/^www\./, '');
      const label = getLinkLabel(target.href, customLabel);

      block.innerHTML = `
        <a href="${escapeHtml(target.href)}" class="lg-bookmark-card" target="_blank" rel="noopener noreferrer">
          ${image ? `
            <div class="lg-bookmark-card__media">
              <img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy">
            </div>
          ` : ''}
          <div class="lg-bookmark-card__body">
            <p class="lg-bookmark-card__domain">${escapeHtml(domain)}</p>
            <h3 class="lg-bookmark-card__title">${escapeHtml(title)}</h3>
            ${description ? `<p class="lg-bookmark-card__text">${escapeHtml(description)}</p>` : ''}
            <span class="lg-bookmark-card__link">${escapeHtml(label)}</span>
          </div>
        </a>
      `;
    } catch (error) {
      block.remove();
      console.error('Auto bookmark preview error:', error);
    }
  });
});